import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["text", "trigger", "fullText"]

  connect() {
    requestAnimationFrame(() => this.#checkTruncation())
  }

  disconnect() {
    this.#removePopover()
  }

  show(event) {
    event.stopPropagation()
    if (this._popover) return
    this.#attachPopover()
  }

  #checkTruncation() {
    const el = this.textTarget
    if (el.scrollHeight > el.clientHeight + 1) {
      this.triggerTarget.classList.remove("hidden")
    }
  }

  #attachPopover() {
    const card = this.element.closest('[id^="post_card_"]') || this.element
    const rect = card.getBoundingClientRect()
    const fullText = this.fullTextTarget.textContent.trim()

    const popover = document.createElement("div")
    popover.className = "caption-popover"
    popover.style.cssText = `
      position: absolute;
      top: ${rect.top + window.scrollY}px;
      left: ${rect.left + window.scrollX}px;
      width: ${rect.width}px;
      transform: translateY(calc(-100% - 8px));
      z-index: 9999;
    `

    const inner = document.createElement("div")
    inner.className = "caption-popover-inner"

    const header = document.createElement("div")
    header.className = "caption-popover-header"

    const label = document.createElement("span")
    label.className = "caption-popover-label"
    label.textContent = "Caption"

    const closeBtn = document.createElement("button")
    closeBtn.className = "caption-popover-close"
    closeBtn.type = "button"
    closeBtn.textContent = "✕"
    closeBtn.addEventListener("click", (e) => {
      e.stopPropagation()
      this.#removePopover()
    })

    header.append(label, closeBtn)

    const body = document.createElement("p")
    body.className = "caption-popover-body"
    body.textContent = fullText

    inner.append(header, body)
    popover.append(inner)
    document.body.appendChild(popover)
    this._popover = popover

    this._outsideClick = (e) => {
      if (!popover.contains(e.target) && e.target !== this.triggerTarget) {
        this.#removePopover()
      }
    }
    setTimeout(() => document.addEventListener("click", this._outsideClick), 0)
  }

  #removePopover() {
    this._popover?.remove()
    this._popover = null
    document.removeEventListener("click", this._outsideClick)
  }
}
